const formatNumber = require('format-number')({
    integerSeparator: " ",
    decimalsSeparator: " ",
    decimal: ","
});

const urls = [
  '/finance/content-distribution-mobile-fotogallery/widget.js',
  '/finance/cian-cd-partners-badge/widget.js',
  '/finance/content-distribution-maps-elements/widget.js',
  '/finance/content-distribution-calculator/widget.js',
  '/finance/content-distribution-call-tracking-button/widget.js',
  '/finance/builder-info-block-mini/widget.js',
  '/finance/price-history/widget.js',
  '/finance/mortgage-button/widget.js',
  '/finance/call-tracking-button-light/widget.js',
  '/finance/offer-card-mini/widget.js',
  '/finance/breadcrumbs/widget.js',
  '/finance/cian-favorites-component/widget.js',
  '/finance/cian-shahe-component/widget.js'
];

urls.forEach((url) => {
    if (!document.querySelector(`script[src="//cdn.cian.site${url}"]`)) {
        const scriptTag = document.createElement("script");
        scriptTag.type = "text/javascript";
        scriptTag.charset = 'utf-8';
        scriptTag.src = `//cdn.cian.site${url}`;
        document.head.appendChild(scriptTag);
    }
});

if (!customElements.get('content-distribution-mobile-offercard')) customElements.define('content-distribution-mobile-offercard', class extends HTMLElement {
    async connectedCallback() {
        if (document.readyState !== 'complete') {
            window.addEventListener('load', () => this.init());
        } else {
            this.init();
        }
        this.addEventListener('click', e => {
            if (e.target.hasAttribute('navigation-main' || e.target.closest('[navigation-main]'))) {
                const customEvent = new CustomEvent('GO_MAIN', {bubbles: true});
                customEvent.newTab = false;
                console.log(customEvent)
                this.dispatchEvent(customEvent);
                e.stopPropagation();
            }
            if (e.target.hasAttribute('navigation-jk-search' || e.target.closest('[navigation-jk-search]'))) {
                const customEvent = new CustomEvent('FIND_JK_LIST', {bubbles: true});
                const bankSuffix = window.cian_bank_id ? `&banks[0]=${window.cian_bank_id}` : "";
                const queryString = localStorage.getItem('jk-search-query-string') || '';
                customEvent.queryString = `${queryString}${bankSuffix}`;
                customEvent.newTab = false;
                console.log(customEvent)
                this.dispatchEvent(customEvent);
                e.stopPropagation();
            }
            if (e.target.hasAttribute('navigation-search' || e.target.closest('[navigation-search]'))) {
                const customEvent = new CustomEvent('FIND_LIST', {bubbles: true});
                customEvent.queryString = localStorage.getItem('search-query-string') || '';
                customEvent.newTab = false;
                console.log(customEvent)
                this.dispatchEvent(customEvent);
                e.stopPropagation();
            }
            if (e.target.hasAttribute('calculator-link') || e.target.closest('[calculator-link]')) {
                const calculatorElement = this.querySelector('cian-finance-calculator');
                if (calculatorElement) window.scrollTo({top: calculatorElement.offsetTop});
                return;
            }
            const jkLink = e.target.hasAttribute('jk-ref') ? e.target : e.target.closest('[jk-ref]');
            if (jkLink) {
                const customEvent = new CustomEvent('SHOW_JK', {bubbles: true});
                customEvent.jkRef = jkLink.getAttribute('jk-ref');
                customEvent.newTab = true;
                this.dispatchEvent(customEvent);
                return;
            }
        });
        const financeAnnuity = this.querySelector('finance-annuity');
        if (financeAnnuity) {
            const miniPayment = this.querySelector('[mini-payment]');
            if (miniPayment) {
                miniPayment.innerHTML = financeAnnuity.innerHTML.replace(/₽/g, '');
            }
        }
        this.addEventListener('change-payment', e => {
            const miniPayment = this.querySelector('[mini-payment]');
            if (miniPayment) {
                miniPayment.innerHTML = formatNumber(e.detail.value);
            }
        });

        const rateTemplate = this.querySelector('cian-finance-credit-rate-display');
        if (rateTemplate) {
            const miniRate = this.querySelector('[mini-rate]');
            if (miniRate) {
                miniRate.innerHTML = rateTemplate.innerHTML.replace(/%/g, '');
            }
        }
        this.addEventListener('rate-updated', e => {
            const miniRate = this.querySelector('[mini-rate]');
            if (miniRate) {
                miniRate.innerHTML = formatNumber(e.detail.value);
            }
        });
    }

    async init() {
        try {
            const isPartnerObject = this.isPartnerProgram();
            this.querySelector('mortgage-button').setAttribute('isPartnerObject', isPartnerObject)
            this.querySelector('call-tracking-button-light').setAttribute('isPartnerObject', isPartnerObject)

            const offerId = this.getAttribute('offer-id');
            const propertyType = this.getAttribute('property-type');
            const regionId = this.getAttribute('region-id');
            const oblastId = this.getAttribute('oblast-id');
            let cianCdUser = localStorage.getItem('cianCdUser');
            let cianCdSession = sessionStorage.getItem('cianCdSession');
            let cianUserAbGroup = localStorage.getItem('cianUserAbGroup');
            const pwa = !!window.sessionStorage && sessionStorage.getItem('pwa') === 'true'
            const response = await fetch(
                'https://cd-business-events-collector.content.cian.ru/events/',
                {
                    credentials: "include",
                    method: 'POST',
                    body: JSON.stringify({
                        'serviceName': 'offer-card-mobile',
                        'eventType': 'visited',
                        'propertyType': propertyType,
                        'offerId': offerId,
                        'data': {
                            'isPartnerObject': isPartnerObject,
                            'regionId': regionId,
                            'oblastId': oblastId,
                            'cianCdUser': cianCdUser,
                            'cianCdSession': cianCdSession,
                            'cianUserAbGroup': cianUserAbGroup,
                            'pwa': pwa
                        }
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    }
                });
            const responseData = await response.json();
            console.log('visited saved: ', responseData);
            localStorage.setItem('cianCdUser', responseData.cianCdUser);
            sessionStorage.setItem('cianCdSession', responseData.cianCdSession);
            localStorage.setItem('cianUserAbGroup', responseData.cianUserAbGroup);
        } catch (e) {
            console.log('===============failed save visited===============')
            console.log(e.toJSON())
        }

    }

    isPartnerProgram = () => {
        const partnerProgramsString = localStorage.getItem('partner-programs');
        const partnerPrograms = !!partnerProgramsString && JSON.parse(partnerProgramsString);
        if (!!partnerPrograms) {
            const cianUserId = this.getAttribute('cian-user-id');
            const partnerProgram = partnerPrograms.find(p => p.cian_user_id === cianUserId);
            return !!partnerProgram
        } else return false;
    }
});
